<template>
    <slot></slot>
</template>

<script>
import { computed } from 'vue';

export default {
    props: {
        name: {
            type: [String, Number],
            default: null,
        },
    },
    inject: {
        form: {
            default: {
                inputErrors: {},
                hasNewElements: () => {},
            },
        }
    },
	provide() {
        return {
            form: computed(() => ({
                ...this.form,
                inputErrors: this.form.inputErrors?.[this.name],
            }))
        };
	},
}
</script>